/**
 * Doubt Service for iTeach Teacher App
 * Handles all API calls related to teacher doubt management
 */

import type {
  Doubt,
  DoubtStatistics,
  StudentSummary,
  ResolveDoubtRequest,
  DoubtFilters,
} from '../types/doubt.types';
import Config from '../_config/config';
import myAxios from '../_services/axiositeachWrapper';

class DoubtService {
  private readonly baseUrl = `${Config.nodeSiteUrl}v1/doubts`;

  async getAllDoubts(filters: DoubtFilters = {}): Promise<Doubt[]> {
    const res = await myAxios.get<any>(this.baseUrl, { params: filters });
    return res.data?.data ?? res.data;
  }

  async getStudentSummaries(): Promise<StudentSummary[]> {
    const res = await myAxios.get<any>(`${this.baseUrl}/student-summaries`);
    return res.data?.data ?? res.data;
  }

  async getStatistics(filters: DoubtFilters = {}): Promise<DoubtStatistics> {
    const { courseId, dateFrom, dateTo } = filters;
    const res = await myAxios.get<any>(`${this.baseUrl}/statistics`, {
      params: { courseId, dateFrom, dateTo },
    });
    return res.data?.data ?? res.data;
  }

  async resolveDoubt(doubtId: string, resolution: ResolveDoubtRequest): Promise<Doubt> {
    const res = await myAxios.post<any>(`${this.baseUrl}/${doubtId}/resolve`, resolution);
    return res.data?.data ?? res.data;
  }

  async updateDoubt(doubtId: string, updates: Partial<Doubt>): Promise<Doubt> {
    const res = await myAxios.patch<any>(`${this.baseUrl}/${doubtId}`, updates);
    return res.data?.data ?? res.data;
  }

  async getStudentDoubts(studentId: number, filters: DoubtFilters = {}): Promise<Doubt[]> {
    const { status, courseId, limit, offset } = filters;
    const res = await myAxios.get<any>(`${this.baseUrl}/student/${studentId}`, {
      params: { status, courseId, limit, offset },
    });
    return res.data?.data ?? res.data;
  }
}

const doubtService = new DoubtService();
export default doubtService;
